import { PropsWithChildren } from 'react';

import { StyledForm } from './Form.styles';

type Props = {
  onSubmit: () => void;
};

export const Form = ({
  children,
  onSubmit,
  ...rest
}: PropsWithChildren<Props>) => {
  return (
    <StyledForm onSubmit={onSubmit} {...rest}>
      {children}
    </StyledForm>
  );
};
